export const LOCAL_STORAGE_KEY = 'MEDIAPRESS_POLL_VOTES';
